<template>
    <div class="bodyPage">
        <v-data-table
            :headers="tableHeaders"
            :items="products || []"
            class="elevation-4 class"
            :loading="loading"
            :loading-text="labels.textLoading"
            v-resize="onResize"
            :search="search"
            :items-per-page=50
            :footer-props="{
                'items-per-page-text': labels.itemsPerPage,
                showFirstLastpage:true,
                'items-per-page-options':[10, 50, 100, -1]
            }"
        >
            <template v-slot:top>
                <v-toolbar flat >
                    <v-toolbar-title>{{'Produtos' | translate('Produtos')}}</v-toolbar-title>
                    <v-divider
                        class="mx-4"
                        inset
                        vertical
                    ></v-divider>
                    <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        :label="labels.buscar"
                        single-line
                        hide-details
                    ></v-text-field>
                    <v-divider
                        class="mx-4"
                        inset
                        vertical
                    ></v-divider>
                    <v-dialog
                        v-model="dialog"
                        scrollable
                        :max-width="editDialogWidth"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                class="btn1" 
                                v-bind="attrs"
                                v-on="on"
                                dark
                                small
                                @click="clearEdititem()"
                            >
                                <v-icon small>
                                    mdi-plus
                                </v-icon>
                                <span>{{ 'Novo' | translate('Produtos') }}</span>
                            </v-btn>
                        </template>
                        <v-form ref="form">
                            <v-card :loading="loading">
                                <v-card-title>
                                    <span class="headline">{{ 'Cadastro de produto' | translate('Produtos')}} </span>
                                </v-card-title>
                                <v-divider></v-divider>
                                <v-card-text class="registrationDialog">
                                    <v-container>
                                        <v-row>
                                            <v-col cols="6">
                                                <v-text-field
                                                    :loading="loading"
                                                    v-model="editedItem.NOME"
                                                    :label="labels.descricao"
                                                    :rules="[rules.required]"
                                                    required
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="6">
                                                <v-text-field
                                                    type="number"
                                                    :loading="loading"
                                                    v-model="editedItem.VALOR"
                                                    :label="labels.valor + ' (R$/h)'"
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12">
                                                <v-text-field
                                                    :loading="loading"
                                                    v-model="editedItem.DESCRICAO"
                                                    :label="labels.descricao_detalhada"
                                                    :rules="[rules.required]"
                                                    required
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        class="white--text btn1" 
                                        small
                                        color="black"
                                        @click="close"
                                    >
                                        {{'Cancel' | translate('Produtos')}}
                                    </v-btn>
                                    <v-btn 
                                        class="white--text btn1" 
                                        small
                                        color="black"
                                        @click="save"
                                        :disabled="validateForm()"
                                    >
                                        {{'Salvar' | translate('Produtos')}}
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-form>
                    </v-dialog>
                </v-toolbar>
            </template>
            <template v-slot:[`item.VALOR`]="{ item }">
                <money style="text-align: end;" v-model="item.VALOR" v-bind="numberMask" disabled></money>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <v-row>
                    <v-col class="actionButtons">
                        <v-btn 
                            icon 
                            @click="editItem(item)"
                        >
                            <v-icon
                                small
                                color="black"
                            >
                                mdi-pencil
                            </v-icon>
                        </v-btn>
                    </v-col>
                    <v-col class="actionButtons">
                        <v-btn 
                            icon 
                            @click="deleteItem(item)"
                        >
                            <v-icon
                                small
                                color="black"
                            >
                                mdi-delete
                            </v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </template>
        </v-data-table>
        <v-dialog v-model="dialogDelete" max-width="fit-content">
            <v-card>
                <v-card-title>
                    {{'Você realmente deseja excluir este produto? ' | translate('Produtos')}} {{editedItem.NOME}}
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn  
                        class="white--text btn1" 
                        small
                        color="black"
                        @click="deleteCalcel"
                    >
                        {{'Cancelar' | translate('Produtos')}}
                    </v-btn>
                    <v-btn  
                        class="white--text btn1" 
                        small
                        color="black"
                        @click="deleteConfirm"
                    >
                        {{'Sim' | translate('Produtos')}}
                    </v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import translate from '../../../../src/plugins/translate'
import laodAllByCompanyId from '../../../../src/app/produto/loadAllByCompanyId'
import addProduct from '../../../../src/app/produto/addProduct'
import updateProduct from '../../../../src/app/produto/updateProduct'
import deleteProduct from '../../../../src/app/produto/deleteProduct'
import createNumberMask from 'text-mask-addons/dist/createNumberMask'
import { createNamespacedHelpers } from 'vuex'

const user = createNamespacedHelpers('user')
const currencyMask = createNumberMask({
    prefix: '$',
    allowDecimal: true,
    includeThousandsSeparator: true,
    allowNegative: false,
});
export default {
    name: 'Produtos',
    components: {},
    data() {
        return {
            currencyMask,
            numberMask: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$/h ',
                suffix: '',
                precision: 2,
                masked: false
            },
            search: null,
            editDialogWidth: '800px',
            dialog: false,
            dialogDelete: false,
            loading: false,
            products: [],
            editedItem: {VALOR:null},
            tableHeaders: [
                { text: translate('Descrição', 'Produtos'), value: 'NOME', filterable: true, width: '70%' },
                { text: translate('Valor', 'Produtos'), value: 'VALOR', filterable: true, width: '15%', align:'end' },
                { text: translate('Ações', 'Produtos'), value: 'actions', sortable: false, width: '15%', align:'center' }
            ],
            labels: {
                textLoading: translate('Carregando Produtos', 'Produtos'),
                buscar: translate('Buscar', 'Produtos'),
                descricao: translate('Descricao', 'Produtos'),
                valor: translate('Valor', 'Produtos'),
                descricao_detalhada: translate('Descricao Detalhada', 'Produtos')
            },
            rules: {
                required: (val) => !!val || translate('Deve ser preenchido!','Produtos')
            },
        }
    },
    methods: {
        async loadProducts() {
            await laodAllByCompanyId(this.user.EMPRESA_ID)
                .then(function(response){
                    this.products = response.data
                    this.loading = false
                }.bind(this))
                .catch(function(){ this.loading = false }.bind(this))
        },
        changeRouter(route) {
            this.$router.push(route)
        },
        onResize () {
            this.windowSize = { x: window.innerWidth, y: window.innerHeight }
            if(this.windowSize.x < 800) this.editDialogWidth = '600px'
            else if(this.windowSize.x < 1025) this.editDialogWidth = '860px'
            else this.editDialogWidth = '1000px'
        },
        deleteItem(item) {
            this.editedItem = Object.assign({}, item)
            this.dialogDelete = true
        },
        deleteCalcel () {
            this.editedItem = {VALOR:null}
            this.dialogDelete = false
        },
        clearEdititem(){
            this.editedItem = {VALOR:null}
        },
        async deleteConfirm () {
            this.dialogDelete = false
            this.loading = true
            await deleteProduct(this.editedItem.ID).then(function(){
                this.loading = false
                this.loadProducts()
            }.bind(this))
            .catch(this.refresh)
            this.close()
        },
        validateForm() {
            if(!this.editedItem.NOME || !this.editedItem.NOME.length)  return true
            if(!this.editedItem.VALOR || !this.editedItem.VALOR.toString().length)  return true
            if(!this.editedItem.DESCRICAO || !this.editedItem.DESCRICAO.length)  return true
            return false
        },
        close () {
            this.editedItem = {VALOR:0}
            this.editedItem = {VALOR:null}
            this.dialog = false
        },
        editItem (item) {
            this.editedItem = Object.assign({}, item)
            this.dialog = true
        },
        async save() {
            this.loading = true
            var self = this
            self.editedItem.EMPRESA_ID = self.user.EMPRESA_ID
            await self.editedItem.ID ? updateProduct(self.editedItem).then(self.loadProducts).catch(self.refresh) : addProduct(self.editedItem).then(self.loadProducts).catch(self.refresh)
            self.editedItem = {VALOR:null}
            self.close()
        },
        refresh(){
            this.loading = false
        }
    },
    computed:{
        ...user.mapGetters(['user'])
    },
    async mounted() {
        this.onResize()
        this.loading = true
        await this.loadProducts()
    },

}
</script>
<style scoped>
.headerPage{
    height: 2rem;
}
.table{
    width: 90%;
}
.titlePage{
    font-size: 16px;
    font-weight: 700;
}
.el-tabs__item.is-active{
    color:black !important;
}
.el-tabs__active-bar{
    background-color: #000000 !important;
}
@media only screen and (max-width: 600px) {
    table{
        width: 100%;
    }
}
@media only screen and (min-width: 601px) and (max-width: 820px){
    .table{
        width: 100%;
    }
}
</style>
